import ApplicationRecord from '@/models/application_record'

import {
  Model,
  Attr
} from 'spraypaint'

@Model()
export default class Role extends ApplicationRecord {
  static jsonapiType = 'roles'

  @Attr name!: string
}
